angular.module("dx.webapp.importStudents", [
	"digiexam.node",
	"digiexam.services",

	"dx.webapp.validation",
	"dx.webapp.api",
	"dx.webapp.session",
	"dx.webapp.navigation",

	"dx.ui.components.localize",

	"ngPasteFrom",
]);
